var THF = THF || {};
THF.Interface = THF.Interface || {};

(function ($, jQuery) {
    'use strict';

    THF.Interface.HealthHubHomePageTracking = function (options) {

        var defaults = {

            selectors: {
                parentElem: '.health-hub-home',
                articleTilePrimary: '.article-tile-primary',
                categoriesCtas: '.categories-ctas',
                categoryTile: '.category-tile',
                articleFeatureTile: '.article-tile-featured',
                serviceTile: '.hh-service-tile'
            }
        };

        options = $.extend(true, {}, defaults, options);


        /**********************************
         // Declare DOM elements
         **********************************/
        var parentElem = $(options.selectors.parentElem);
        var articleTilePrimary = $parentElem(options.selectors.articleTilePrimary);
        var articleTilePrimaryButton = articleTilePrimary.find('a');

        var categoriesCtas = $parentElem(options.selectors.categoriesCtas);
        var categoryTiles = categoriesCtas.find(options.selectors.categoryTile);

        var articleFeatureTiles = $parentElem(options.selectors.articleFeatureTile);
        var articleFeatureTileButtons = articleFeatureTiles.find('a');

        var serviceTiles = $parentElem(options.selectors.serviceTile);
        var serviceTileButtons = serviceTiles.find('a');

        /**********************************
         // Helper function to return a jQuery object, which is a child of 'parentElem'
         **********************************/
        function $parentElem(selector) {
            return $(options.selectors.parentElem + ' ' + selector);
        }


        /**********************************
         // Event binding
         **********************************/
        function bindEvents() {

            /* Home Page Primary Article Tile */
            articleTilePrimaryButton.click(function (e) {
                //e.preventDefault();
                //console.log('Home Page >> Single Primary Article Tile clicked.');
                //console.log('pagePath: ' + $(this).attr('href'));
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'landingMainCard',
                    'type': 'Article',
                    'version': 'Spotlight',
                    'pagePath': $(this).attr('href')
                });
            });

            /* Home Page >> Feature Article Tile */
            articleFeatureTileButtons.each(function () {
                var articleFeatureTileButton = $(this);
                articleFeatureTileButton.click(function (e) {
                    //e.preventDefault();
                    //console.log('Home Page >> Feature Article Tile clicked.');
                    //console.log('pagePath: ' + $(this).attr('href'));
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'landingMainCard',
                        'type': 'Article',
                        'version': 'Card',
                        'pagePath': $(this).attr('href')
                    });
                });
            });

            /* Home Page >> Service Tile */
            serviceTileButtons.each(function () {
                var serviceTileButton = $(this);
                serviceTileButton.click(function (e) {
                    //e.preventDefault();
                    //console.log('Home Page >> Service Tile clicked.');
                    //console.log('pagePath: ' + $(this).attr('href'));
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'landingMainCard',
                        'type': 'Service Tile',
                        'version': 'Card',
                        'pagePath': $(this).attr('href')
                    });
                });
            });


            /* Home Page Category Tiles : Browse More Categories */
            categoryTiles.each(function () {
                var categoryTile = $(this);
                var categoryTileBrowseButton = categoryTile.find('a');
                categoryTileBrowseButton.click(function (e) {
                    //e.preventDefault();
                    //console.log('Home Page >> Browse More Articles >> Category Tile clicked.');
                    //console.log('pagePath: ' + $(this).attr('href'));
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'LandingBrowseMoreCard',
                        'type': 'Category',
                        'pagePath': $(this).attr('href')
                    });
                });
            });
        }

        /**********************************
         // Simple constructor
         **********************************/
        function __construct() {

            // Init
            if (parentElem.length > 0) {
                bindEvents();
            }
        }

        __construct();


        //
        // Make some events accessible from global scope
        //
        return {

        };
    };
})(jQuery, jQuery)